import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 600px;
  min-height: 420px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  position: relative;
`
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 550px;
  height: 40px;
`

export const CancelButton = styled.button`
  width: 24px;
  height: 24px;
  cursor: pointer;
  border: none;
  background: none;
`

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.ds.colors.neutral900};
`

export const Separator = styled.div`
  height: 1px;
  background-color: #dadee2;
  margin: 14px 0;
`
export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 24px;
`
